import type { Transition, Variants } from 'framer-motion'

/** Shared easing — a soft, expensive-feeling out-curve. */
export const easeOutExpo: [number, number, number, number] = [0.22, 1, 0.36, 1]

export const viewportOnce = { once: true, margin: '-80px' }

export const springSoft: Transition = { type: 'spring', stiffness: 180, damping: 22, mass: 0.6 }
export const springSnappy: Transition = { type: 'spring', stiffness: 420, damping: 26, mass: 0.5 }

/** Parent container that cascades its children in. */
export function staggerContainer(stagger = 0.09, delayChildren = 0.04): Variants {
  return {
    hidden: {},
    show: {
      transition: { staggerChildren: stagger, delayChildren },
    },
  }
}

/** Child item: subtle y-offset + fade (fade only under reduced motion). */
export function fadeUp(reduced: boolean, distance = 28, duration = 0.6): Variants {
  return {
    hidden: { opacity: 0, y: reduced ? 0 : distance },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: reduced ? 0.3 : duration, ease: easeOutExpo },
    },
  }
}

/** Child item: slides in from the left (fade only under reduced motion). */
export function fadeInX(reduced: boolean, distance = -24, duration = 0.55): Variants {
  return {
    hidden: { opacity: 0, x: reduced ? 0 : distance },
    show: {
      opacity: 1,
      x: 0,
      transition: { duration: reduced ? 0.3 : duration, ease: easeOutExpo },
    },
  }
}

/** Media reveal: fade + a whisper of scale. */
export function fadeScale(reduced: boolean, from = 0.96, duration = 0.7): Variants {
  return {
    hidden: { opacity: 0, scale: reduced ? 1 : from },
    show: {
      opacity: 1,
      scale: 1,
      transition: { duration: reduced ? 0.3 : duration, ease: easeOutExpo },
    },
  }
}
